var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkUrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-2{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Workspace"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 24,
    width: 24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.54,14.5a7,7,0,0,1-13.08,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.46,9.5a7,7,0,0,1,13.08,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.46,
    x2: 18.54,
    y1: 9.5,
    y2: 9.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.46,
    x2: 18.54,
    y1: 14.5,
    y2: 14.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "4 11 5 13 6 11 7 13 8 11"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "10 11 11 13 12 11 13 13 14 11"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "16 11 17 13 18 11 19 13 20 11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.68,9.5A9.21,9.21,0,0,0,12,5,9.18,9.18,0,0,0,9.33,9.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.32,14.5A9.21,9.21,0,0,0,12,19a9.21,9.21,0,0,0,2.68-4.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkUrl);
export default __webpack_public_path__ + "static/media/iconLinkUrl.0db12d7d575347117ca62e13e312e52b.svg";
export { ForwardRef as ReactComponent };